<template>
  <v-container class="limited">
    <dados-beneficiario></dados-beneficiario>
    <extrato-pormenorizado-grid
      :dados-beneficiario="dadosBeneficiario"
    ></extrato-pormenorizado-grid>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

import DadosBeneficiario from "@/components/BeneficiaryData";
import ExtratoPormenorizadoGrid from "./extrato-pormenorizado";

const { mapState } = createNamespacedHelpers("beneficiario");

export default {
  name: "ExtratoPormenorizado",
  components: {
    DadosBeneficiario,
    ExtratoPormenorizadoGrid
  },
  computed: mapState(["dadosBeneficiario"])
};
</script>
